import type { ChangeEvent } from "react";
import styled from "styled-components";
import { hexToRGB } from "../../utils/style";
import { ErrorMessage } from "./ErrorMessage";

/**
 * [共通パーツ]日付入力
 */

export type InputDateProps = {
  value?: string;
  number?: boolean;
  error?: boolean;
  errorMessages?: string[];
  min?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const Container = styled.div`
  display: flex;
  height: 44px;
`;

const StyledInput = styled.input<InputDateProps>`
  background-color: ${(props) =>
    props.error
      ? hexToRGB(props.theme.colors.caution, 0.05)
      : props.theme.colors.inputFieldBackground};
  color: ${(props) => props.theme.colors.primaryText};
  font-size: ${(props) => props.theme.fontSize.small};
  padding: 13px 10px;
  border: 1px solid
    ${(props) =>
      props.error
        ? props.theme.colors.caution
        : props.theme.colors.primaryBorder};
  border-radius: 6px;
  outline: 0;
  width: 100%;
`;

export function InputDate({
  value = "",
  error = false,
  onChange,
  errorMessages,
  number = false,
  min,
}: InputDateProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    number
      ? event.target.value
          .split("")
          .every((char) => !isNaN(parseInt(char, 10))) && onChange(event)
      : onChange(event);
  };
  return (
    <>
      <Container>
        <StyledInput
          type="date"
          value={value}
          error={error}
          onChange={handleChange}
          min={min}
        />
      </Container>
      <ErrorMessage
        errorMessage={
          errorMessages && errorMessages.find((message) => message !== "")
        }
      />
    </>
  );
}
